import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { Receipt } from "src/app/models/receipt.model";
import { ModalService } from "src/app/services/modal.service";
import { constants } from "../../../utils/constants";
import { IErrorAlert } from "../../../interfaces/error.interface";
import { RequestService } from '../../../services/request.service';
import helpers from 'src/app/utils/helpers';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: "app-edit-receipt",
  templateUrl: "./edit-receipt.component.html",
  styleUrls: [
    "../edit-receipt/edit-receipt.component.css",
    "../new-receipt/new-receipt.component.css",
    "../receipt-modal/receipt-modal.component.css",
  ],
})
export class EditReceiptComponent implements OnInit, OnDestroy {
  
  @Input() events: Observable<void>;
  @Input() initEvents: Observable<number>;
  @Input() receipt: Receipt;

  private hidingEventsSubscription: Subscription;
  private initEventsSubscription: Subscription;


  constants = constants;
  helpers = helpers;
  form: FormGroup;
  loading = false;
  error: IErrorAlert;

  banks: string[] = null;
  currencies: any[] = ["Soles", "Dolares"];

  constructor(
    public _modal: ModalService,
    public _request: RequestService,
    public _auth: AuthService,
    private _fb: FormBuilder,
  ) {
    this.initEvents = _modal.initEvents.asObservable();
  }

  ngOnInit(): void {
    this.init();
    this.hidingEventsSubscription = this.events.subscribe(() => this.hide());
    this.initEventsSubscription = this.initEvents.subscribe(() => this.init());
  }
  
  init() {
    this.receipt = this._modal.receipt;
    this.loading = true;
    this.getBankList();
    this.initForm();
  }

  ngOnDestroy() {
    this.hidingEventsSubscription.unsubscribe();
    this.initEventsSubscription.unsubscribe();
  }

  edit() {
    this.receipt = new Receipt({...this.receipt, ...this.form.value, amount: parseFloat(this.form.get('amount').value) });
    this.loading = true;
    this._request.updateReceipt(this._modal.request, this.receipt).subscribe(
      () => {
        this._modal.request.replaceReceipt(this.receipt);
        this._modal.success = true;
        this.loading = false;
      },
      (err) => {
        this.error = {...err, width: 'auto'};
        this.loading = false;
      }
    )
  }

  hide() {
    this._modal.hide();
    this.error = null;
  }

  getBankList() {
    this._request.getBankList(this._auth.user).subscribe(
      (bankList: string[]) => {
        this.banks = bankList;
        this.loading = false;
      },
      (err) => {
        this.error = {...err, width: 'auto'};
        this.loading = false
      }
    )
  }

  initForm() {
    this.form = this._fb.group({
      issuingBank: [this.receipt.issuingBank, Validators.required],
      issuingBankNumber: [
        this.receipt.issuingBankNumber,
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern(constants.validations.numeric.pattern),
        ],
      ],
      receivingBank: [this.receipt.receivingBank, Validators.required],
      transferDate: [this.receipt.transferDate, Validators.required],
      amount: [this.receipt.amount, [Validators.required, helpers.invalidAmount]],
      currency: [{ value: this.receipt.currency, disabled: true }, Validators.required],
      operationNumber: [
        this.receipt.operationNumber,
        [Validators.required, Validators.maxLength(30)],
      ],
      observation: [this.receipt.observation],
    });
    this.helpers.initFormListeners(this.form);
  }
}
